import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';

import PrivateRoute from './privateRoute';
import LoginPage from '../components/loginPage'; 
import LogoutPage from '../components/logoutPage'; 
import DashboardPage from '../components/dashboardPage';
import Cls from '../components/cls';
import { checkCookie } from '../utils/cookies';
class App extends Component {
  render() {
    if(checkCookie() === null){
      localStorage.setItem('url', window.location.href);
    } 
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route path='/' exact={true} component={LoginPage} />
            <Route path='/login' component={LoginPage} />
            <Route path='/logout' component={LogoutPage} /> 
            <PrivateRoute path='/dashboard' component={DashboardPage} />
            <PrivateRoute path='/cls/:id' component={Cls} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;